const SecondaryFeatureTextEnums = new Map();

SecondaryFeatureTextEnums.set(1, 'sms_feature');
SecondaryFeatureTextEnums.set(2, 'sellCropPrimaryHeading'); //
SecondaryFeatureTextEnums.set(3, 'bahi_khata');
SecondaryFeatureTextEnums.set(4, 'cropAdvisory');
SecondaryFeatureTextEnums.set(5, 'rake');
SecondaryFeatureTextEnums.set(6, 'expenseManagerPrimaryHeading'); //
SecondaryFeatureTextEnums.set(7, 'mandiRatePrimaryHeading'); //
SecondaryFeatureTextEnums.set(8, 'distributor_list');

export default SecondaryFeatureTextEnums;
